import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../../../common/constants';
import CombinedNewOrderTable from './components/NewOrderTable';
import ReturnTable from './components/ReturnTable';
import New from './pages/CombinedOrders';

const UserOrdersWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}`}
      render={(props) => <New {...props} />}
    />

    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}${ROUTES?.NEW}/:userId`}
      render={(props) => <CombinedNewOrderTable {...props} />}
    />

    <Route
      exact
      path={`${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}${ROUTES?.RETURN}/:userId`}
      render={(props) => <ReturnTable {...props} />}
    />
  </Switch>
);

export default UserOrdersWrapper;
